import { Fragment, useState } from "react";
import "./ContactModel.scss";
import Modal from "react-bootstrap/Modal";
import DomesticForm from "./DomesticForm";
import InternationalForm from "./InternationalForm";

import { motion } from "framer-motion";
import { IoMdClose } from "react-icons/io";

import { formRange } from "../../utils/enum";
import useExecuteContext from "../../utils/hooks/executeContext";

const ContactModel = () => {
  const [typeStatus, setTypeStatus] = useState(false);
  const [countryStatus, setCountryStatus] = useState(false);

  const { showContact, setShowContact, formType, setFormType } = useExecuteContext();
  const [loader, setLoader] = useState(false);
  const [success, setSuccess] = useState(false);
  const handleClose = () => {
    setShowContact(false);
  };

  return (
    <Modal
      size="lg"
      show={showContact}
      onHide={handleClose}
      centered
      className="contact_model"
    >
      <Modal.Body>      
        <button type="button" className="close" onClick={handleClose}>
          <IoMdClose />
        </button>
        <motion.div
          initial={{ scaleY: 0, opacity: 0 }}
          whileInView={{ scaleY: 1, opacity: 1 }}
          transition={{
            duration: 1,
            ease: "easeInOut",
          }}
        >
          <div
            className="form_wrap"
            onClick={() => {
              setCountryStatus(false);
              setTypeStatus(false);
            }}
          >
            {success ? (
              <div className="form_wrapsuccess_screen">
                <h5 className="text-center darkGold">Thanks!</h5>
                <p className="text-center darkGold">
                  Thank you for reaching out! Our team will get back to you
                  soon.
                </p>
              </div>
            ) : (
              <Fragment>
                <h5 className="darkGold">Contact Us Now</h5>
                <div className="btn_line">
                  <button
                    type="button"
                    className={`type_btn ${
                      formType == formRange?.DOMESTIC ? "active" : ""
                    }`}
                    onClick={() => {
                      setFormType(formRange?.DOMESTIC);
                    }}
                  >
                  Indian Residents
                  </button>
                  <button
                    type="button"
                    className={`type_btn ${
                      formType == formRange?.INTERNATIONAL ? "active" : ""
                    }`}
                    onClick={() => {
                      setFormType(formRange?.INTERNATIONAL);
                    }}
                  >
                    NRI's
                  </button>
                </div>

                {/* Domestic Form */}
                {formType === formRange?.DOMESTIC && (
                  <DomesticForm
                    setLoader={setLoader}
                    loader={loader}
                    setSuccess={setSuccess}
                    typeStatus={typeStatus}
                    setTypeStatus={setTypeStatus}
                  />
                )}

                {/* International Form */}
                {formType === formRange?.INTERNATIONAL && (
                  <InternationalForm
                    setLoader={setLoader}
                    loader={loader}
                    setSuccess={setSuccess}
                    typeStatus={typeStatus}
                    setTypeStatus={setTypeStatus}
                    countryStatus={countryStatus}
                    setCountryStatus={setCountryStatus}
                  />
                )}
              </Fragment>
            )}
          </div>
          <motion.div
            initial={{ scaleX: 0, opacity: 0 }}
            whileInView={{ scaleX: 1, opacity: 1 }}
            transition={{
              duration: 0.8,
              ease: "easeInOut",
              delay: 1,
            }}
            className="strip a"
          ></motion.div>
          <motion.div
            initial={{ scaleX: 0, opacity: 0 }}
            whileInView={{ scaleX: 1, opacity: 1 }}
            transition={{
              duration: 0.8,
              ease: "easeInOut",
              delay: 1.2,
            }}
            className="strip b"
          ></motion.div>
          <motion.div
            initial={{ scaleX: 0, opacity: 0 }}
            whileInView={{ scaleX: 1, opacity: 1 }}
            transition={{
              duration: 0.8,
              ease: "easeInOut",
              delay: 1.4,
            }}
            className="strip c"
          ></motion.div>
        </motion.div>
      </Modal.Body>
    </Modal>
  );
};

export default ContactModel;
